export default __webpack_public_path__ + "static/media/5.blur.6598c03b.jpg";